import request from '@/utils/request'

const labelFilePathApi = {
  getLabelResourceList: '/train/rest/label_file/get_label_resource_list',
  getLabelResourceList2: '/train/rest/label_file/get_label_resource_list2',
  getLabelResourceListNew:'get_label_resource_list_new',
  addLabelResource: '/train/rest/label_file/add_resource2',
  updateLabelResourceName: '/train/rest/label_file/update_resource_name',
  updateLabelResourceChildName: '/train/rest/label_file/update_resource_child',
  removeLabelResource: '/train/rest/label_file/remove_resource',
  addLabelResourceChild: '/train/rest/label_file/add_resource_child',
  getfatherId: '/train/rest/label_file/get_parent',
  removeLabelResourceChild: '/train/rest/label_file/remove_resource_child'
}

const labelFileApi = {
   getPage: '/train/rest/label_file/v2/get_page_file',
   remove: '/train/rest/label_file/remove_file',
   removes:'/train/rest/label_file/remove_files',
   clear:'/train/rest/label_file/clear_all'
}

export function getLabelResourceList (parameter) {
  return request({
    url: labelFilePathApi.getLabelResourceList + '/' + `${parameter}`,
    method: 'get'
  })
}

export function getLabelResourceListNew(){
  return request({
    url: labelFilePathApi.getLabelResourceListNew,
    method: 'get'
  })
}
export function getLabelResourceList2 (parameter) {
  return request({
    url: labelFilePathApi.getLabelResourceList2 + '/' + `${parameter}`,
    method: 'get'
  })
}

export function getfatherId (parameter) {
  return request({
    url: labelFilePathApi.getfatherId,
    method: 'get',
    params: parameter
  })
}

export function addLabelResource (parameter) {
  return request({
    url: labelFilePathApi.addLabelResource,
    method: 'post',
    data: parameter
  })
}

export function addLabelResourceChild (parameter) {
  return request({
    url: labelFilePathApi.addLabelResourceChild,
    method: 'post',
    data: parameter
  })
}

export function updateLabelResourceName (parameter) {
  return request({
    url: labelFilePathApi.updateLabelResourceName,
    method: 'post',
    data: parameter
  })
}

export function updateLabelResourceChildName (parameter) {
  return request({
    url: labelFilePathApi.updateLabelResourceChildName,
    method: 'post',
    data: parameter
  })
}

export function removeLabelResourceName (parameter) {
  return request({
    url: labelFilePathApi.removeLabelResource,
    method: 'post',
    data: parameter
  })
}

export function removeLabelResourceChild (parameter) {
  return request({
    url: labelFilePathApi.removeLabelResourceChild,
    method: 'post',
    data: parameter
  })
}
export function getLabelFilePage (parameter) {
  return request({
    url: labelFileApi.getPage,
    method: 'get',
    params: parameter
  })
}

export function removeFile (parameter) {
  return request({
    url: labelFileApi.remove,
    method: 'post',
    data: parameter
  })
}

export function removeFiles(parameter){
  return request({
    url: labelFileApi.removes,
    method: 'post',
    data: parameter
  })
}

export function clearAll(parameter){
  return request({
    url: labelFileApi.clear,
    method: 'post',
    data: parameter
  })
}

export function showSign (filePathId) {
  return request({
    url: `/train/rest/label_file/permit_label?filePathId=${filePathId}`,
    method: 'get'
  })
}
/*
 * 获取标签
*/
export function getTags (filePathId) {
  return request({
    url: `/train/rest/label/get_list?filePathId=${filePathId}`,
    method: 'get'
  })
}

/*
 * 提交标签
*/
export function subTags (data) {
  return request({
    url: `/train/rest/label/add`,
    method: 'post',
    data: data
  })
}
/*
 * 删除标签
*/
export function removeTags (data) {
  return request({
    url: `/train/rest/label/remove`,
    method: 'post',
    data: data
  })
}

/*
 * 提交标注信息
*/
export function subSigns (data) {
  return request({
    url: `/train/rest/label_file/do_label`,
    method: 'post',
    data: data
  })
}



